import Insured from '@/modules/common/common/models/APP/Insured'

export default class DentalHiringInsured extends Insured {
  hasRelationship!: string

  constructor(data: Partial<DentalHiringInsured> = {}) {
    super(data)
  }
}
